import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { useStyles } from './AppFeatures.styles';
import theme from '../../../styles/theme';
import { useAccess } from '../../../hooks/useAccess';
import { useAppFeaturesComponent } from './useAppFeaturesComponent';
import Search from '../../../components/reusable/search/Search';
import FlexibleColumnsTable from '../../../components/reusable/Table/FlexibleColumnsTable';
import { AppFeaturesFilter } from './AppFeaturesFilter';

function AppFeatures() {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    sortedArray,
    columnsList,
    order,
    orderBy,
    cellReducers,
    onSort,
    onSortColumns,
    filter,
    setFilter,
    filterFormik,
    filterIsActiveOptions,
  } = useAppFeaturesComponent(classes);
  const { access } = useAccess();

  return (
    <div className={classes.wrapper}>
      <AppFeaturesFilter
        formik={filterFormik}
        filterIsActiveOptions={filterIsActiveOptions}
      />
      <Box display="flex" gap={1} alignItems="center" marginBottom={2}>
        <Search fullWidth value={filter} onChange={setFilter} />
      </Box>
      <FlexibleColumnsTable
        data={sortedArray}
        columnsList={columnsList}
        order={order}
        orderBy={orderBy}
        onSort={onSort}
        classes={classes}
        onSortColumns={onSortColumns}
        cellReducers={cellReducers}
        onSelectAllRows={() => {}}
        stickyHeader={true}
      />
    </div>
  );
}

export default AppFeatures;
